import { render, staticRenderFns } from "./wap-link.vue?vue&type=template&id=51e0ec87&scoped=true&"
import script from "./wap-link.vue?vue&type=script&lang=js&"
export * from "./wap-link.vue?vue&type=script&lang=js&"
import style0 from "./wap-link.vue?vue&type=style&index=0&id=51e0ec87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e0ec87",
  null
  
)

export default component.exports